export const FLOW_ACTION_TYPES = [
  {
    key: 'create_calendar_event',
    label: 'Criar Evento na Agenda',
    inputType: 'calendar_event',
  },
  {
    key: 'schedule_meeting',
    label: 'Agendar Reunião',
    inputType: 'calendar_event',
  },
  {
    key: 'assign_task_to_conversation',
    label: 'Atribuir Tarefa a Conversa',
    inputType: 'search_select',
  },
  {
    key: 'assign_task_to_contact',
    label: 'Atribuir Tarefa ao Contato',
    inputType: 'search_select',
  },
  {
    key: 'assign_task_to_company',
    label: 'Atribuir Tarefa à Empresa',
    inputType: 'search_select',
  },
  {
    key: 'complete_conversation_task',
    label: 'Concluir Tarefa de Conversa',
    inputType: 'search_select',
  },
  {
    key: 'complete_contact_task',
    label: 'Concluir Tarefa de Contato',
    inputType: 'search_select',
  },
  {
    key: 'complete_company_task',
    label: 'Concluir Tarefa de Empresa',
    inputType: 'search_select',
  },
  {
    key: 'start_typebot',
    label: 'Iniciar Bot',
    inputType: 'start_typebot_command',
  },
  {
    key: 'stop_typebot',
    label: 'Parar Bot',
    inputType: null,
  },
  {
    key: 'reset_typebot',
    label: 'Reiniciar Bot',
    inputType: null,
  },
  {
    key: 'start_ai_agent',
    label: 'Ligar Agente de IA',
    inputType: 'start_ai_agent',
  },
  {
    key: 'stop_ai_agent',
    label: 'Parar bot e IA',
    inputType: null,
  },
  {
    key: 'reset_ai_agent',
    label: 'Reiniciar bot e IA',
    inputType: null,
  },
  {
    key: 'execute_flow',
    label: 'Disparar fluxo manual',
    inputType: 'search_select',
  },
  // Um bloco só para CSAT e NPS: o que separa os dois é o `kind` do medidor
  // escolhido no dropdown, não a ação (#751).
  {
    key: 'send_survey',
    label: 'Enviar Pesquisa (CSAT/NPS)',
    inputType: 'search_select',
  },
  {
    key: 'assign_team',
    label: 'Atribuir um Setor a Conversa',
    inputType: 'search_select',
  },
  {
    key: 'assign_agent',
    label: 'Atribuir um Atendente a Conversa',
    inputType: 'search_select',
  },
  {
    key: 'assign_team_to_contact',
    label: 'Atribuir um Setor ao Contato',
    inputType: 'search_select',
  },
  {
    key: 'assign_agent_to_contact',
    label: 'Atribuir um Atendente ao Contato',
    inputType: 'search_select',
  },
  {
    key: 'add_conversation_label',
    label: 'Adicionar etiqueta na conversa',
    inputType: 'multi_select',
  },
  {
    key: 'remove_conversation_label',
    label: 'Remover etiqueta da conversa',
    inputType: 'multi_select',
  },
  {
    key: 'add_contact_label',
    label: 'Adicionar etiqueta no contato',
    inputType: 'multi_select',
  },
  {
    key: 'add_company_label',
    label: 'Adicionar etiqueta na empresa',
    inputType: 'multi_select',
  },
  {
    key: 'remove_company_label',
    label: 'Remover etiqueta da empresa',
    inputType: 'multi_select',
  },
  {
    key: 'create_company',
    label: 'Criar empresa',
    inputType: 'company',
  },
  {
    key: 'update_company',
    label: 'Atualizar empresa',
    inputType: 'company',
  },
  {
    key: 'assign_company_agent',
    label: 'Atribuir Atendente à Empresa',
    inputType: 'company_assignment',
  },
  {
    key: 'assign_company_team',
    label: 'Atribuir Setor à Empresa',
    inputType: 'company_assignment',
  },
  {
    key: 'set_company_custom_attributes',
    label: 'Inserir Campo Personalizado na Empresa',
    inputType: 'custom_attribute',
  },
  {
    key: 'remove_company_custom_attributes',
    label: 'Remover Campo Personalizado da Empresa',
    inputType: 'custom_attribute',
  },
  {
    key: 'associate_company_to_conversation',
    label: 'Associar empresa à conversa',
    inputType: 'company',
  },
  {
    key: 'associate_company_to_contact',
    label: 'Associar empresa ao contato',
    inputType: 'company',
  },
  {
    key: 'associate_company_to_company',
    label: 'Associar empresa à empresa',
    inputType: 'company',
  },
  {
    key: 'remove_contact_label',
    label: 'Remover etiqueta do contato',
    inputType: 'multi_select',
  },
  {
    key: 'remove_assigned_team',
    label: 'Remover Setor da Conversa',
    inputType: null,
  },
  {
    key: 'assign_franchise_unit',
    label: 'Associar Unidade do Franqueado à Conversa',
    inputType: 'franchise_unit',
  },
  {
    key: 'remove_franchise_unit',
    label: 'Desassociar Unidade do Franqueado da Conversa',
    inputType: null,
  },
  {
    key: 'remove_assigned_agent',
    label: 'Remover Atendente da Conversa',
    inputType: null,
  },
  {
    key: 'remove_contact_assigned_team',
    label: 'Remover Setor do Contato',
    inputType: null,
  },
  {
    key: 'remove_contact_assigned_agent',
    label: 'Remover Atendente do Contato',
    inputType: null,
  },
  {
    key: 'send_email_transcript',
    label: 'Enviar uma transcrição por email',
    inputType: 'email',
  },
  {
    key: 'mute_conversation',
    label: 'Bloquear contato',
    inputType: null,
  },
  {
    key: 'snooze_conversation',
    label: 'Adiar conversa',
    inputType: null,
  },
  {
    key: 'resolve_conversation',
    label: 'Resolver conversa',
    inputType: null,
  },
  {
    key: 'open_conversation',
    label: 'Abrir conversa',
    inputType: null,
  },
  {
    key: 'send_webhook_event',
    label: 'Enviar Evento Webhook',
    inputType: 'url',
  },
  {
    key: 'send_attachment',
    label: 'Enviar Anexo',
    inputType: 'attachment',
  },
  {
    key: 'send_message',
    label: 'Enviar uma mensagem',
    inputType: 'message_with_inbox',
  },
  {
    key: 'send_template',
    label: 'Enviar template do WhatsApp Oficial',
    inputType: 'whatsapp_template',
  },
  {
    key: 'send_button',
    label: 'Enviar botão',
    inputType: 'interactive_button',
  },
  {
    key: 'send_list',
    label: 'Enviar lista',
    inputType: 'interactive_list',
  },
  {
    key: 'send_carousel',
    label: 'Enviar carrossel',
    inputType: 'interactive_carousel',
  },
  {
    key: 'send_poll',
    label: 'Enviar enquete',
    inputType: 'interactive_poll',
  },
  {
    key: 'add_private_note',
    label: 'Adicionar uma nota privada',
    inputType: 'textarea',
  },
  {
    key: 'change_priority',
    label: 'Alterar Prioridade',
    inputType: 'search_select',
  },
  {
    key: 'add_custom_attribute',
    label: 'Inserir Campo Personalizado na Conversa',
    inputType: 'custom_attribute',
  },
  {
    key: 'add_custom_attribute_to_contact',
    label: 'Inserir Campo Personalizado no Contato',
    inputType: 'custom_attribute_contact',
  },
  {
    key: 'schedule_message',
    label: 'Agendar Mensagem',
    inputType: 'schedule_message',
  },
  {
    key: 'cancel_scheduled_messages',
    label: 'Cancelar Todos os Agendamentos',
    inputType: null,
  },
  {
    key: 'delete_scheduled_messages',
    label: 'Excluir Todos os Agendamentos',
    inputType: null,
  },
];

// Chaves em que o rótulo do catálogo de AÇÕES **não** é o nome do bloco dentro
// do motor de fluxos (issue #934). Hoje só `execute_flow`, e é o caso de uma
// chave só nomeando duas coisas:
//
//   | onde | código | nome verdadeiro |
//   |---|---|---|
//   | ações manuais / automação legada | ManualActionService#execute_flow | "Disparar fluxo manual" |
//   | passo de fluxo | Steps::ExecuteFlowStep | "Executar sub-fluxo" |
//
// Quem mostra PASSO DE FLUXO consulta este conjunto ANTES do catálogo e cai em
// `AUTOMATION_FLOWS.BLOCKS.LABELS.<chave>`. Vive aqui, e não dentro de uma tela,
// porque são três superfícies lendo a mesma coisa — `FlowEditor.label()`,
// `FlowItem.stepLabel()` e o `FlowExecutionCanvas` (esse já lê só o i18n). Uma
// cópia por tela é como o nome divergiu da primeira vez.
export const BLOCK_LABEL_OVERRIDE = new Set(['execute_flow']);
